import type { Resource } from '../../';
export const cart_cartItem_sizeDisplay: Resource = {"default":"Size: {size}"};
